import { FileTextOutlined } from '@ant-design/icons'
import { useId, useRef, useState } from 'react'
import './ProductInstruction.css'

export function ProductInstruction({
  html,
  children,
  title = 'Как использовать покупку',
  hint = 'Откройте инструкцию перед использованием кода.',
}) {
  const [open, setOpen] = useState(false)
  const trigger = useRef(null)
  const contentId = useId()

  if (!children && (typeof html !== 'string' || !html.trim())) return null

  const collapse = () => {
    setOpen(false)
    trigger.current?.focus({ preventScroll: true })
    trigger.current?.scrollIntoView({ block: 'nearest' })
  }

  return <section className='product-instruction' aria-label='Инструкция к товару'>
    <h2 className='product-instruction__heading'>
      <button
        type='button'
        className='product-instruction__trigger'
        ref={trigger}
        aria-expanded={open}
        aria-controls={contentId}
        onClick={() => setOpen(value => !value)}
      >
        <span className='product-instruction__icon' aria-hidden='true'><FileTextOutlined /></span>
        <span className='product-instruction__copy'>
          <span className='product-instruction__kicker'>ИНСТРУКЦИЯ К ТОВАРУ</span>
          <span className='product-instruction__title'>{title}</span>
          <span className='product-instruction__hint'>{hint}</span>
        </span>
        <span className='product-instruction__action'>
          {open ? 'Свернуть' : 'Открыть инструкцию'}
          <span className='product-instruction__chevron' aria-hidden='true' />
        </span>
      </button>
    </h2>
    <div id={contentId} hidden={!open}>
      {children ? <div className='product-instruction__body'>{children}</div>
        : <div className='product-instruction__body' dangerouslySetInnerHTML={{ __html: html }} />}
      <div className='product-instruction__footer'>
        <button type='button' onClick={collapse}>Свернуть инструкцию <span aria-hidden='true'>↑</span></button>
      </div>
    </div>
  </section>
}
